/**
 * i18next initialization for the client.
 *
 * MVP ships English only (FR-018). Adding a language is "create a new
 * locales/<code>.json + register it here + add a locale switcher in UI".
 * No component changes required.
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json' with { type: 'json' }

i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false }, // React escapes by default
  // Crash loudly during dev if a key is missing; in prod just log and
  // render the key path so users still see *something*.
  missingKeyHandler: (_lngs, _ns, key) => {
    if (import.meta.env.DEV) {
      throw new Error(`i18n: missing translation key "${key}"`)
    }
  },
  saveMissing: import.meta.env.DEV,
})

export default i18n
